// IT
export const calendarsChatbotHc = {
  monthlyCalendar: {
    pricesTitle: "Prezzi dinamici",
    prices: "Prezzi",
    noPropertiesAvailable: "Nessuna struttura disponibile",
    noPropertiesFound: "Nessuna struttura trovata",
    minStayShort: "min. {n}n",
    available: "Disponibile",
    closed: "Chiuso",
    loading: "Caricamento…",
    showMoreMonths: "Mostra altri mesi",
    from: "Dal",
    to: "Al",
    nightsLabelOne: "{n} notte",
    nightsLabelMany: "{n} notti",
    whatToDo: "Cosa vuoi fare?",
    close: "Chiudi",
    open: "Apri",
    price: "Prezzo",
    minStay: "Soggiorno min.",
    closeReasonPlaceholder: "Motivo della chiusura (facoltativo)",
    openHint: "Le date selezionate verranno riaperte (il blocco viene rimosso).",
    nightsWord: "notti",
    clearSelection: "Cancella selezione",
    past: "Passata",
    guestOne: "ospite",
    guestMany: "ospiti",
    perNight: "/ notte",
    noName: "Senza nome",
    channelDirect: "Diretta",
    ownerBlockComment: "Blocco da parte del proprietario",
    prepTime: "Tempo di preparazione",
    sameDayCutoff: "Chiusura in giornata",
    linkedClosed: "Vendita intera",
    linkedClosedInfo: "Chiuso dalla vendita dell'appartamento intero ({motivo}). Si riaprirà da solo se quella prenotazione viene cancellata o cambia date.",
    alsoLinked: "chiuso anche dalla vendita dell'appartamento intero ({motivo})",
    applyClose: "Chiudi date",
    applyOpen: "Apri date",
    applyPrice: "Salva prezzo",
    applyMinStay: "Salva soggiorno minimo",
    apply: "Applica",
    processing: "Elaborazione…",
    closingDates: "Chiusura date…",
    openingDates: "Apertura date…",
    priceModeLabel: "Modo prezzo",
    priceModeFixed: "Fisso",
    priceModePercent: "%",
    priceModeAmount: "Importo",
    percentPlaceholder: "Es. 20",
    amountPlaceholder: "Es. 10",
    percentHint: "Ogni notte si ricalcola sul proprio prezzo. Con − scende.",
    amountHint: "Si somma a quanto costa già ogni notte. Con − scende.",
    invalidPrice: "Inserisci un prezzo valido.",
    changingPrice: "Modifica del prezzo per notte…",
    priceUpdated: "Prezzo aggiornato correttamente.",
    priceUpdateError: "Impossibile aggiornare il prezzo.",
    minStayMin: "Il soggiorno minimo deve essere di almeno 1 notte.",
    changingMinStay: "Modifica del soggiorno minimo…",
    minStayUpdated: "Soggiorno minimo aggiornato correttamente.",
    minStayUpdateError: "Impossibile aggiornare il soggiorno minimo.",
    unknownError: "Errore sconosciuto",
  },
  calendar: {
    channelDirect: "Diretta",
    searchMin2: "Digita almeno 2 caratteri per cercare",
    searchNoResults: "Nessuna prenotazione trovata per questa ricerca",
    searchError: "Errore durante la ricerca delle prenotazioni",
    processing: "Elaborazione…",
    ownerBlockComment: "Blocco da parte del proprietario",
    cutoffTip: "Chiusura delle vendite in giornata alle {time}",
    nightsLabelOne: "{n} notte",
    nightsLabelMany: "{n} notti",
    turnoverBefore: "Tempo di preparazione: blocca {nights} prima di ogni arrivo",
    turnoverAfter: "Tempo di preparazione: blocca {nights} a partire da ogni partenza",
    turnoverBoth: `Tempo di preparazione: blocca {nights} prima dell'arrivo e a partire dalla partenza`,
    selectAtLeastOneProperty: "Seleziona almeno una struttura.",
    selectAtLeastOneDate: "Seleziona almeno una data effettiva per applicare le modifiche.",
    preparingOps: "Preparazione di {total} operazioni...",
    applyingOps: "Applicazione di {index} di {total}: {name}",
    unknownError: "Errore sconosciuto",
    couldNotSaveChanges: "Impossibile salvare le modifiche.",
    bulkApplyError: "Impossibile applicare le modifiche di massa. {message}",
    opsApplied: "Applicate {success} operazioni su {total}.",
    opsSkipped: "{skipped} date con prenotazioni confermate sono state ignorate.",
    opsFailed: "{failed} operazioni non riuscite.",
    bulkApplied: "Modifica di massa applicata a {count} strutture.",
    couldNotOpenDate: "Impossibile aprire la data",
    datesOpened: "Date aperte",
    closeUpdated: "Blocco aggiornato",
    todayLabel: "Oggi",
    closed: "Chiuso",
    linkedClosed: "Vendita intera",
    linkedClosedInfo: "Chiuso dalla vendita dell'appartamento intero ({motivo}). Si riaprirà da solo se quella prenotazione viene cancellata o cambia date.",
    alsoLinked: "chiuso anche dalla vendita dell'appartamento intero ({motivo})",
    closingDates: "Chiusura date…",
    couldNotCloseDates: "Impossibile chiudere le date",
    clearFiltersTitle: "Cancella filtri",
    noPropertiesAvailable: "Nessuna struttura disponibile",
    noPropertiesFound: "Nessuna struttura trovata",
    dynamicPricesTitle: "Prezzi dinamici",
    prices: "Prezzi",
    viewWide: "Vista ampia",
    viewCompact: "Vista compatta",
    viewNormal: "Vista normale",
    viewFull: "Visualizza completo",
    searchBookingTitle: "Cerca prenotazione",
    searchBookingPlaceholder: "Cerca prenotazione…",
    search: "Cerca",
    resultsSelectOne: "{count} risultati — selezionane uno:",
    bulkEdit: "Modifica di massa",
    goToTodayTitle: "Vai a oggi",
    showHeader: "Mostra intestazione",
    configArrivalDeparture: "Configura le regole di arrivo e partenza",
    notAvailable: "Non disponibile",
    extension: "Estensione",
    lateCheckoutUntil: "Partenza tardiva fino alle {time}",
    aiRequests: "Reception IA",
    guestComments: "Note dell'ospite",
    internalNotes: "Note interne",
    extrasTitle: "Extra acquistati",
    extrasPending: "In attesa di conferma",
    reqArrivalTitle: "Orario di arrivo",
    reqAt: "alle {time}",
    reqUntil: "fino alle {time}",
    reqNights: "Notti extra: {n}",
    reqPending: "In attesa",
    reqConfirmed: "Confermata",
    reqPaid: "Pagata",
    reqOffered: "Offerta",
    reqPrioritised: "Prioritaria",
    pendingAmount: "Da pagare:",
    noticesColumn: "Avvisi",
    callsTitle: "Chiamate",
    callsCount: "Chiamate: {n}",
    extensionPaid: "Estensione pagata",
    listCheckin: "Arrivo",
    listCheckout: "Partenza",
    priceOriginal: "Prenotazione originale",
    priceExtension: "Estensione",
    priceTotal: "Totale",
    paymentInProcess: "Pagamento in corso",
    overbooking: "Overbooking",
    noAccommodationsFound: `Nessuna struttura trovata con "{term}".`,
    past: "Passata",
    paymentInProcessLower: "pagamento in corso",
    pendingApproval: "in attesa di approvazione",
    pendingApprovalTitle: "In attesa di approvazione",
    guestOne: "ospite",
    guestMany: "ospiti",
    perNight: "/ notte",
  },
  tableFilters: {
    filterByDate: "Filtra per data dal - al",
    filterByCountry: "Filtra per paese",
    all: "Tutti",
    countrySpain: "Spagna",
    countryColombia: "Colombia",
    countryBrazil: "Brasile",
    filterByState: "Filtra per stato",
    allStates: "Tutti gli stati",
    stateDemo: "Versione demo",
    stateSubscribed: "Abbonati",
    stateNotSubscribed: "Non abbonati",
    searchRecords: "Cerca nei record",
  },
  chatbotPageIndex: {
    aiAgentBadge: "Agente IA",
    planFeatureHint: "Funzionalità disponibile con un piano a pagamento.",
    otaAgentTitle: "Agente IA per le OTA",
    otaAgentHint: `Attivalo affinché l'agente risponda automaticamente ai messaggi di Booking, Airbnb e altre OTA.`,
    otaRequiresWhatsapp: `Richiede l'Agente IA di WhatsApp attivo.`,
    guardNotice: `Con l'Agente IA disattivato, anche la chat passa automaticamente alla <strong>risposta manuale</strong>. Gli interruttori per conversazione resteranno bloccati finché non lo riattivi.`,
    configureBasic: "Configura agente IA di base",
    configureAdvanced: "Configura agente IA avanzato",
    comingSoon: "Prossimamente",
    detailFallback: "Dettaglio",
    errorLoadListingConfig: `Impossibile caricare la configurazione dell'annuncio`,
    errorSaveChange: "Errore durante il salvataggio della modifica",
    otaAgentActivated: "Agente IA per le OTA attivato",
    otaAgentDeactivated: "Agente IA per le OTA disattivato",
  },
  chatbotIndex: {
    accommodationFallback: "Struttura",
    defaultHandoffSupportLine: "\nSe hai bisogno di assistenza rapida, contattaci al {phone} 📞",
    defaultHandoffMessage: "Ciao 😊 Al momento non ho questa informazione, ma un membro del nostro team ti assisterà a breve 🙌{suffix}\nSiamo a tua disposizione per tutta la durata del soggiorno! 🏡✨",
    silentModeMessage: `Non verrà inviata alcuna risposta automatica all'ospite. Il sistema continuerà a notificare l'operatore affinché possa proseguire la conversazione.`,
    statusNoGuestReply: `Nessuna risposta all'ospite`,
    statusUsingCustom: "Messaggio personalizzato in uso",
    statusUsingDefault: "Messaggio predefinito in uso",
    helperSilent: `L'ospite non riceverà una risposta automatica quando l'Agente IA non sa cosa rispondere, ma l'operatore riceverà la notifica per prendere in carico la conversazione.`,
    helperCustom: `Il sistema tradurrà automaticamente questo messaggio personalizzato nella lingua dell'ospite.`,
    helperHasCustom: "Hai un messaggio personalizzato salvato, ma per ora il sistema continuerà a usare il messaggio predefinito.",
    helperDefault: `Se crei un messaggio principale, potrai attivarlo qui e il sistema lo tradurrà automaticamente nella lingua dell'ospite.`,
    sourceSilent: "Silenzioso",
    sourceCustom: "Personalizzato",
    sourceDefault: "Predefinito",
    defaultBotName: "Il mio assistente virtuale",
    errorLoadBotName: `Impossibile caricare il nome dell'assistente.`,
    errorLoadHandoff: "Impossibile caricare il messaggio di trasferimento.",
    botNameUpdated: `Nome dell'assistente aggiornato.`,
    errorSaveBotName: `Impossibile salvare il nome dell'assistente.`,
    masterMessageUpdated: "Messaggio principale aggiornato.",
    errorSaveMaster: "Impossibile salvare il messaggio principale.",
    warnCreateCustomFirst: "Crea prima un messaggio personalizzato prima di attivarlo.",
    modeCustomActivated: "Ora verrà usato il messaggio personalizzato.",
    modeSilentActivated: `Il bot resterà in silenzio quando non saprà rispondere, ma l'operatore continuerà a ricevere la notifica.`,
    modeDefaultActivated: "Ora verrà usato il messaggio predefinito.",
    errorUpdateActiveMessage: "Impossibile aggiornare il messaggio attivo.",
    warnWriteQuestion: "Scrivi una domanda prima di salvare.",
    questionCreated: "Domanda creata correttamente.",
    errorAddQuestion: "Impossibile aggiungere la domanda.",
    botNamePlaceholder: `Nome dell'assistente`,
    handoffRowTitle: `Messaggio quando l'agente non sa rispondere`,
    customize: "Personalizza",
    expandAria: "Espandi",
    handoffSubtitle: `Questo testo verrà inviato quando l'Agente IA non trova la risposta nei facts, nella memoria o nelle FAQ.`,
    modeDefaultTitle: "Messaggio predefinito",
    modeDefaultDesc: `Usa il messaggio standard del sistema con il numero di telefono dell'assistenza.`,
    modeCustomTitle: "Messaggio personalizzato",
    modeCustomDescActive: "Attiva il testo personalizzato che hai salvato nella finestra.",
    modeCustomDescEmpty: "Non hai ancora creato un messaggio personalizzato.",
    modeSilentTitle: `Non rispondere all'ospite`,
    modeSilentDesc: `L'ospite non riceve un messaggio automatico, ma l'operatore verrà notificato per proseguire la conversazione.`,
    loadingMessage: "Caricamento del messaggio...",
    masterMessage: "Messaggio principale",
    newQuestionTitle: "Nuova domanda",
    newQuestionSubtitle: `Crea una nuova domanda frequente affinché l'Agente IA possa rispondere con maggiore precisione.`,
    guestQuestionLabel: `Domanda dell'ospite`,
    questionPlaceholder: "Es. A che ora è il check-in?",
    questionHelp: "Consiglio: scrivi la domanda come farebbe un ospite reale.",
    cancel: "Annulla",
    saveQuestion: "Salva domanda",
    handoffKicker: "Risposta di trasferimento",
    handoffModalTitle: "Personalizza il messaggio principale",
    handoffModalSubtitle: `Scrivi un solo messaggio in spagnolo. Il sistema lo tradurrà automaticamente e risponderà in base alla lingua parlata dall'ospite.`,
    masterToolbarInfo: "Puoi usare emoji e un tono cordiale, proprio come negli altri messaggi automatici.",
    emojiSearchPlaceholder: "Cerca emoji...",
    masterTextareaPlaceholder: `Scrivi qui il messaggio principale. Puoi usare emoji e un tono caloroso per l'ospite.`,
    masterHint: `Consiglio: scrivi il messaggio in spagnolo con il tono esatto che vuoi trasmettere. Il sistema lo adatterà automaticamente alla lingua dell'ospite.`,
    viewDefaultMessage: "Visualizza il messaggio predefinito",
    saveMessage: "Salva messaggio",
    newButton: "Nuova",
    emojiButton: "Emoji",
  },
  messageAccountDemo: {
    usingDemo: "Stai usando la versione demo",
    ofThePlatform: "della piattaforma",
    trialHave: "Hai ancora",
    trialDaysToEnjoy: "giorni per goderti tutte le funzionalità!",
    trialSubscribeNow: "Abbonati ora e continua a gestire le tue strutture senza interruzioni.",
    subscribeNowLabel: "Abbonati ora",
  },
};
